export default __webpack_public_path__ + "static/media/ShareIcon.0ff22b8f.svg";